import React from 'react';
import {
    GaugeControl,
    TriggerPad
} from './Common';
import './Common.css';
import TR808Drum, {
    DrumTime,
    TR808DrumOptions
} from '../../../audio/instruments/TR808Drum';


interface DrumPadSetupProps {
    name: string;
    padDefinition: DrumPadElementGroup;
    update: (v: Partial<TR808DrumOptions>) => void;
}

const DrumPadSetup: React.FC<DrumPadSetupProps> = ({ name, padDefinition, update }) => {
    return (
        <div
            style={{
                border: '1px solid #ccc',
                borderRadius: '2px',
                marginLeft: '2px',
                width: '50px',
            }}
        >
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                <span style={{ textAlign: 'center', fontWeight: 'bold' }}>{name}</span>
                <DrumPad
                    key={padDefinition.name}
                    trigger={padDefinition.trigger}
                />
                <GaugeControl label="Volume" />
                <GaugeControl label="Decay" />
            </div>
        </div>
    );
};

export function DrumPadGroup({
    name,
    children
}: {
    name: string,
    children?: React.ReactNode
}) {
    return (
        <div className='ryd--trigger-pad-group--wrapper'>
            <div className='ryd--trigger-pad-group--container'>
                <span style={{ textAlign: 'center', fontWeight: 'bold' }}>{name}</span>
                {children}
            </div>
        </div>
    );
}

const DrumPad = TriggerPad;
export type DrumPadElementGroup = {
    name: string,
    trigger?: (time?: DrumTime) => void
};

export function DrumKit({
    drum
}: {
    drum: TR808Drum
}) {
    return (
        <>
            <div style={{ padding: '2px' }} className='ryd-instrument-wrapper'>
                <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
                    <DrumPadGroup name="Kick">
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerKick(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                        <GaugeControl label="Pitch decay" />
                    </DrumPadGroup>
                    <DrumPadGroup name="Snare">
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerSnare(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                    </DrumPadGroup>
                    <DrumPadGroup name="Rim">
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerRim(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                    </DrumPadGroup>
                    <DrumPadGroup name="C-Hat">
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerClosedHat(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                    </DrumPadGroup>
                    <DrumPadGroup name="O-Hat" >
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerOpenHat(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                    </DrumPadGroup>
                    <DrumPadGroup name="L-Tom">
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerLowTom(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                    </DrumPadGroup>
                    <DrumPadGroup name="M-Tom" >
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerMidTom(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                    </DrumPadGroup>
                    <DrumPadGroup name="H-Tom" >
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerHighTom(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                    </DrumPadGroup>
                    <DrumPadGroup name="Clap" >
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerClap(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Spread" />
                    </DrumPadGroup>
                    <DrumPadGroup name="Cymbal" >
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerCymbal(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                    </DrumPadGroup>
                    <DrumPadGroup name="Cowbell" >
                        <DrumPad
                            trigger={(t?: DrumTime) => drum.triggerCowbell(t)}
                        />
                        <GaugeControl label="Volume" />
                        <GaugeControl label="Decay" />
                        <GaugeControl label="Tone" />
                    </DrumPadGroup>
                </div>
            </div>
        </>
    );
};

